export class TextbookDemoForbiddenError extends Error {
  constructor(msg = 'Textbook-demo-forbidden') {
    super(msg);
  }
}
